<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      :search.sync="searchForm"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="tempCarBllChangeLogListForm">
        <el-table :data="form.tempCarBllChangeLogList" min-height="250" border style="width: 100%">
          <el-table-column prop="operateTime" label="操作时间" width="180"> </el-table-column>
          <el-table-column prop="operatePerson" label="操作人" width="180"> </el-table-column>
          <el-table-column prop="operateDescription" label="操作信息"> </el-table-column>
        </el-table>
      </template>
      <template slot="spaceNameSearch">
        <selectSearch  v-model="parkingLotId" :dicData="parkingLotList"  @change="getOutPassage"></selectSearch>
        <!-- <el-select v-model="parkingLotId" @change="getOutPassage">
          <el-option
            v-for="item in parkingLotList"
            :key="item"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select> -->
      </template>
      <template slot="outPassageNameSearch">
        <el-select v-model="searchForm.outPassageName" placeholder="出场通道名称">
          <el-option
            v-for="item in outPassageList"
            :key="item.id"
            :value="item.passageName"
            :label="item.passageName"
          ></el-option>
        </el-select>
      </template>
      <template slot="outPassageNameForm">
        <el-select v-model="form.outPassageName" placeholder="请选择 出场通道名称">
          <el-option
            v-for="item in outPassageList"
            :key="item.id"
            :value="item.passageName"
            :label="item.passageName"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="payTimeSearch">
        <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.payTimeStart"
              type="date"
              default-time="00:00:00"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payTimeEnd"
              type="date"
              default-time="23:59:59"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>

      <template slot="chargeTotal" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeTotal) }}
      </template>
      <template slot="discountAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.discountAmount) }}
      </template>
      <template slot="chargeAmount" slot-scope="scope">
        {{ tool.money_format_allowvoid(scope.row.chargeAmount) }}
      </template>

      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openTempCarPayDetail(scope.row, 'view')"
          >支付明细
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openDialogShowImg(scope.row)"
          >图片
        </el-button>
      </template>
    </avue-crud>
    <tempCarPayDetail
      v-if="tempCarPayDetailVisible"
      :visible.sync="tempCarPayDetailVisible"
      :tempCarBillId="tempCarBillId"
      :spaceId="spaceId"
    ></tempCarPayDetail>
    <el-dialog
      :visible.sync="showImgDialog"
      title="进出场图片查看"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      :modal-append-to-body="false"
    >
      <div v-if="showImgDialog" style="display:flex;">
        <div style="flex-shrink: 1;flex-grow: 1;margin-right: 2px;min-width: 50%;">
          <div style="text-align:center;margin-bottom:15px;">入场图片</div>
          <el-image :src="inImage" width="100%" alt="" />
        </div>
        <div style="flex-shrink: 1;flex-grow: 1;margin-left: 2px;min-width: 50%;">
          <div style="text-align:center;margin-bottom:15px;">出场图片</div>
          <el-image :src="outImage" width="100%" alt="" />
        </div>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getFreeOpenReason,
  getReason
} from '@/api/v4ward/carv2/tempcarbill';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import tempCarPayDetail from './temp-car-pay-detail.vue';
import fastSelectTime from '@/views/v4ward/a-components/fast-select-time.vue';
import { getOutPassage } from '@/api/v4ward/carv2/carinoutinfo.js';
import func from '@/util/func';
export default {
  components: { tempCarPayDetail, fastSelectTime },
  data() {
    return {
      inImage: '',
      outImage: '',
      showImgDialog: false,
      tempCarBillId: '',
      spaceId: '',
      tempCarPayDetailVisible: false,
      payTimeRange:'',
      form: {
        payTimeRange:[],
        outPassageName: '',
      },
      query: {
        payTimeStart:'',
        payTimeEnd:'',
      },
      searchForm: {
        payTimeRange:[],
        outPassageName: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      outPassageList: [],
      selectionList: [],
      parkingLotId: '',
      parkingLotList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 24,
        searchLabelWidth: '110',
        menuWidth: 170,
        border: true,
        index: true,
        viewBtn: false,
        selection: false,
        menu: true,
        columnBtn: true,
        dialogClickModal: false,
        refreshBtn: true,
        stripe: true,
        editBtn: false,
        labelWidth: 110,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            width: 120,
            type: 'select',
            search: true,
            searchslot: true,
            hide: true,
            disabled: true,
            showColumn: false,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
          },

          {
            label: '订单编号',
            search: true,
            prop: 'payNo',
            width: 180,
            disabled: true,
            overHidden: true,
            defaultSort: {
              prop: 'name',
              order: 'descending',
            },
          },
          {
            label: '车牌号',
            search: true,
            disabled: true,
            prop: 'plateNumber',
            width: 90,
          },
          {
            label: '应收金额',
            prop: 'chargeTotal',
            width: 70,
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入应收金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '优惠金额',
            prop: 'discountAmount',
            width: 70,
            slot: true,
            maxlength: 11,

            rules: [
              {
                required: true,
                message: '请输入优惠金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '实收金额',
            prop: 'chargeAmount',
            width: 70,
            slot: true,
            rules: [
              {
                required: true,
                message: '请输入实收金额',
                trigger: 'blur',
              },
              {
                trigger: 'change',
                pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/,
                message: '请输入8位以内最多2位小数金额',
              },
            ],
            align: 'right',
          },
          {
            label: '出场通道名称',
            search: true,
            prop: 'outPassageName',
            width: 140,
            formslot: true,
            searchslot: true,
          },
          {
            label: '入场时间',
            prop: 'inTime',
            width: 160,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择入场时间',
                trigger: 'change',
              },
            ],
            searchSpan: 12,
          },
          {
            label: '出场时间',
            prop: 'outTime',
            width: 150,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请选择出场时间',
                trigger: 'change',
              },
            ],
            searchSpan: 12,
          },
          {
            label: '停车时长',
            prop: 'stopTime',
            disabled: true,
            display: false,
            width: 130,
          },
          {
            label: '是否付款',
            type: 'select',
            prop: 'payStatus',
            width: 90,
            rules: [
              {
                required: true,
                message: '请选择是否付款',
                trigger: 'change',
              },
            ],
            dicData: [
              {
                label: '未付款',
                value: 0,
              },
              {
                label: '已付款',
                value: 1,
              },
            ],
          },
          {
            label: '付款时间',
            prop: 'payTime',
            search: true,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchslot: true,
            searchSpan: 12,
          },
          {
            label: '支付方式',
            prop: 'payType',
            type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictValue',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=park_pay_type',
            width: 80,
          },
          {
            label: '车辆分类',
            prop: 'payType2',
            display: false,
            showColumn: false,
            disabled: true,
            width: 80,
          },
          {
            label: '操作人',
            disabled: true,
            prop: 'opeatorName',
            width: 80,
          },
          {
            label: '开闸原因',
            prop: 'remark',
            type: 'select',
            dicData: [],
            display: false,
            search: true,
            props: {
              label: 'key',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择备注',
                trigger: 'blur',
              },
            ],
            overHidden: true,
          },
          {
            label: '是否付款',
            type: 'select',
            prop: 'searchPayStatus',
            searchSpan: 6,
            search: false,
            showColumn: false,
            display: false,
            hide: true,
            dicData: [
              {
                label: '未付款',
                value: 0,
              },
              {
                label: '已付款',
                value: 1,
              },
            ],
          },
          {
            label: '日志信息',
            prop: 'tempCarBllChangeLogList',
            formslot: true,
            row: true,
            showColumn: false,
            span: 24,
            editDisplay: false,
            addDisplay: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.tempcarbill_add, false),
        viewBtn: this.vaildData(this.permission.tempcarbill_view, false),
        delBtn: this.vaildData(this.permission.tempcarbill_delete, false),
        editBtn: this.vaildData(this.permission.tempcarbill_edit, false),
        exportBtn: this.vaildData(this.permission.parkblacklist_export, false),
        payDetailsBtn: this.vaildData(this.permission.tempcarbill_pay_details, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },

  created() {
    this.initTimeRange();
    this.option.height = this.bodyHeight - 430;
    getSpaceTree().then((data) => {
      this.parkingLotList = data.data;
      if (data.data.length > 0) {
        this.parkingLotId = this.parkingLotList[0].id;
      }
      this.getOutPassage(this.parkingLotId);
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 430) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 430;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    initTimeRange() {
      var startTime = func.getCurrentMonthFirst() + ' 00:00:00';
      var endTime = func.getCurrentMonthLast() + ' 23:59:59';
      this.payTimeRange = [startTime, endTime];
    },
    // 查看进出场图片
    openDialogShowImg(row) {
      this.outImage = row.outImage;
      this.inImage = row.inImage;
      this.showImgDialog = true;
    },
    // 查看支付明细
    openTempCarPayDetail(row) {
      this.tempCarBillId = row.id;
      this.spaceId = row.parkingLotId;
      this.tempCarPayDetailVisible = true;
    },
    // 获取出场通道
    getOutPassage(spaceId) {
      getOutPassage({ spaceId: spaceId }).then((res) => {
        this.outPassageList = res.data;
        this.searchForm.outPassageName = '';
      });
      // 获取免费开闸原因
      this.searchForm.remark = "";
      let remarkColumn = this.findObject(this.option.column, 'remark');
      getReason({ spaceId: spaceId }).then((res) => {
        remarkColumn.dicData = res.data;
        this.$refs.crud.updateDic('remark', res.data);
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      if (Number(row.chargeTotal) < 0.01) {
        this.$message.error('应收金额不能小于0.01');
        loading();
        return;
      }
      this.outPassageList.forEach((ele) => {
        if (ele.passageName == row.outPassageName) {
          row.outPassageId = ele.id;
        }
      });
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        let remarkColumn = this.findObject(this.option.column, 'remark');
        // let outPassageNameColumn = this.findObject(this.option.column,'outPassageName');
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          // getOutPassage({spaceId:this.form.parkingLotId}).then(res=>{
          //   outPassageNameColumn.dicData = res.data;
          //   th = res.data;
          // })
          getFreeOpenReason({ spaceId: this.form.parkingLotId }).then((res) => {
            remarkColumn.dicData = res.data;
          });
        });
      }
      done();
    },
    searchReset() {
      this.query.payTimeStart=''
      this.query.payTimeEnd=''
      this.query.payNo =''
      this.query.plateNumber =''
      this.query.outPassageName = ''
      // this.query = {
      //   payTimeRange:[
      //     func.getCurrentMonthFirst() + ' 00:00:00', func.getCurrentMonthLast() + ' 23:59:59'
      //   ],
      // };
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.payNo = params.payNo;
      this.query.plateNumber = params.plateNumber;
      this.query.outPassageName = params.outPassageName;
      
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      console.log("this.payTimeRange",this.payTimeRange);
      console.log("this.query.payTimeRange",this.query.payTimeRange);
      console.log("this.searchForm.payTimeRange",this.searchForm.payTimeRange);
      if (this.vdui.isEmpty(this.parkingLotId)) {
        this.loading = false;
        return;
      }
      // if( this.vdui.isEmpty(this.query.payTimeStart)||this.vdui.isEmpty(this.query.payTimeEnd)){
      //   console.log("****")
      //   this.query.payTimeStart=''
      //   this.query.payTimeEnd=''
      // }
      this.query.parkingLotId = this.parkingLotId;
      page = page || this.page;
      this.loading = true;
      
      this.query.payType = '免费开闸';
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
